module.exports = "../fonts/HelveticaNeueLTW01-65Medium.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-65Medium.woff2
// module id = WIV4
// module chunks = 1